import { ArraySourceComposer } from '@/auth/api/connector'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import {
  ButtonItem,
  ButtonOptions,
  CustomRule,
  Form as DXForm,
  GroupItem,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form'
import { FieldDataChangedEvent } from 'devextreme/ui/form'
import { useRevalidator, useSearchParams } from 'react-router-dom'
import { isUserRoleAllowed } from '@/routes/utils'
import { Roles } from '@/auth/azure/Roles'
import { ExpenseEditorFormProps } from '@/routes/expenses/ExpenseEditor.types'
import { ValidationCallbackData } from 'devextreme/common'

const ExpenseEditorForm = (props: ExpenseEditorFormProps) => {
  const {
    creating,
    expense,
    impiegati,
    tipologie,
    isRoleAllowed,
    userInfo,
    fetcher,
    formRef,
    // readOnlyCreating,
    onSaveClick,
  } = props
  const revalidator = useRevalidator()
  const [searchParams] = useSearchParams()
  const dateSP = searchParams.get('date')
  const employeeEmailSP = searchParams.get('employeeEmail')

  return (
    <>
      <LoadingPanel visible={!(fetcher?.state === 'idle' && revalidator.state === 'idle')} />
      <DXForm
        id={'expense_form'}
        formData={expense}
        labelLocation={'top'}
        showValidationSummary={true}
        onFieldDataChanged={(e: FieldDataChangedEvent) => {
          if (
            formRef.current?.instance().option().isDirty !== null &&
            formRef.current?.instance().option().isDirty !== undefined
          ) {
            console.log('is dirty', formRef.current?.instance().option().isDirty)
            formRef.current
              .instance()
              .getButton('btn-save')
              ?.option('disabled', !formRef.current?.instance().option().isDirty)
            formRef.current
              .instance()
              .getButton('btn-cancel')
              ?.option('disabled', !formRef.current?.instance().option().isDirty)
          }
        }}
        validationGroup="expenseValidation"
        ref={formRef}
        readOnly={
          creating
            ? !isRoleAllowed
            : !isUserRoleAllowed(userInfo?.roles, [Roles.Administrator, Roles.GlobalAdministrator])
        }
      >
        <GroupItem colCountByScreen={{ xs: 1, sm: 2, md: 2, lg: 2 }}>
          <GroupItem colCountByScreen={{ xs: 1, sm: 1, md: 1, lg: 2 }}>
            <SimpleItem
              dataField="impiegato"
              label={{ text: 'Impiegato' }}
              editorType="dxLookup"
              editorOptions={{
                dataSource: ArraySourceComposer('id', impiegati),
                placeholder: 'Seleziona impiegato...',
                displayExpr: 'fullname',
                searchEnabled: true,
                dropDownCentered: true,
                readOnly:
                  !creating ||
                  (!isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.Administrator]) && creating) ||
                  employeeEmailSP !== null,
                dropDownOptions: {
                  showTitle: true,
                  title: "Selezionare l'impiegato",
                  hideOnOutsideClick: true,
                },
              }}
            >
              <RequiredRule message="Impiegato obbligatorio"></RequiredRule>
            </SimpleItem>
            <SimpleItem
              dataField="tipologia"
              label={{ text: 'Tipologia spesa' }}
              editorType="dxLookup"
              editorOptions={{
                dataSource: ArraySourceComposer('id', tipologie),
                placeholder: 'Seleziona tipologia spesa...',
                displayExpr: 'nome',
                searchEnabled: true,
                dropDownCentered: true,
                dropDownOptions: {
                  showTitle: true,
                  title: 'Selezionare la tipologia spesa',
                  hideOnOutsideClick: true,
                },
                readOnly: !isRoleAllowed,
              }}
            >
              <RequiredRule message="Tipologia obbligatoria"></RequiredRule>
            </SimpleItem>
            <SimpleItem
              dataField="data"
              editorOptions={{
                displayFormat: 'dd/MM/yyyy',
                type: 'date',
                pickerType: 'calendar',
                applyValueMode: 'instantly',
                // readOnly: dateSP !== null || readOnlyCreating || !creating,
                readOnly: dateSP !== null || !creating,
                calendarOptions: {
                  showTodayButton: true,
                },
              }}
              editorType="dxDateBox"
              label={{ text: 'Data' }}
            >
              <RequiredRule message="Data obbligatoria" />
              <CustomRule
                reevaluate={true}
                message="Inserire una data dall'ultimo mese solare fino ad oggi"
                validationCallback={({ value }: ValidationCallbackData) => {
                  const receiptDate = new Date(value)
                  const now = new Date()
                  const minDate = new Date(now.getFullYear(), now.getMonth() - 1, 1)
                  console.log(now, minDate)
                  return receiptDate <= now && receiptDate >= minDate
                }}
              ></CustomRule>
            </SimpleItem>
            <SimpleItem
              dataField="totale"
              label={{ text: 'Totale' }}
              editorType="dxNumberBox"
              editorOptions={{
                showSpinButtons: true,
                min: 0,
                // readOnly:
                //   readOnlyCreating ||
                //   (!isUserRoleAllowed(userInfo?.roles, [Roles.Administrator, Roles.GlobalAdministrator]) && !creating),
                readOnly:
                  !isUserRoleAllowed(userInfo?.roles, [Roles.Administrator, Roles.GlobalAdministrator]) && !creating,
              }}
            >
              <RequiredRule message="Totale obbligatorio"></RequiredRule>
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={1}>
            <SimpleItem
              colSpan={3}
              dataField={'note'}
              editorType={'dxTextArea'}
              label={{ visible: true, text: 'Note' }}
              editorOptions={{
                height: 100,
                readOnly: !isRoleAllowed,
              }}
            ></SimpleItem>
          </GroupItem>
        </GroupItem>
        <GroupItem visible={isRoleAllowed} cssClass="last-group">
          <GroupItem cssClass="buttons-group" colCount={2}>
            <ButtonItem name="btn-save">
              <ButtonOptions
                disabled={!formRef.current?.instance().option().isDirty}
                icon="save"
                text="Salva"
                width="160px"
                onClick={onSaveClick}
              />
            </ButtonItem>
            {!creating && (
              <ButtonItem name="btn-cancel">
                <ButtonOptions
                  disabled={!formRef.current?.instance().option().isDirty}
                  width="160px"
                  text="Annulla"
                  icon="undo"
                  onClick={() => {
                    revalidator.revalidate()
                  }}
                />
              </ButtonItem>
            )}
          </GroupItem>
        </GroupItem>
      </DXForm>
    </>
  )
}

export default ExpenseEditorForm
